import { html } from "/WebInterface/new-ui/assets/js/utils/te.js";

const resizableTemplate = html`
  <header class="resizable-header">
    <p class="text-bold text-primaryMain">${"title"}</p>
    <div class="is-flex">
      <button
        class="header-btn resize-button is-cursor-pointer is-hidden"
        type="button"
        aria-label="resize-btn"
      >
        <i class="icon-resize-full text-primaryMain"></i>
      </button>
      <button
        class="header-btn remove-button is-cursor-pointer"
        type="button"
        aria-label="resize-btn"
      >
        <i class="icon-remove text-primaryMain"></i>
      </button>
    </div>
  </header>
  <div class="resizable-body"></div>

  <div class="resizable-nw"></div>
  <div class="resizable-ne"></div>
  <div class="resizable-se"></div>
  <div class="resizable-sw"></div>
</div>
`;

export default resizableTemplate;
